<template>
    <div>
        <div
            v-if="loading"
            class="form-spinner"
        >
            <span class="fa fa-spinner fa-lg fa-pulse" />
        </div>
        <div>
            <div>
                <div class="row">
                    <div class="col col-md-6">
                        <select
                            v-model="tab"
                            class="form-control"
                            @change="emitChange"
                        >
                            <option value=">">
                                Делал заказ
                            </option>
                            <option value="==">
                                Не делал заказ
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="mt-3">
            <div>
                <div class="row">
                    <div class="col col-md-6">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">C: </span>
                            </div>
                            <date-picker
                                ref="start"
                                v-model="start_"
                                :config="startconfig"
                                @dp-change="updateDate($event, 'start')"
                            />
                        </div>
                    </div>
                    <div class="col col-md-6">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">По: </span>
                            </div>
                            <date-picker
                                ref="end"
                                v-model="end_"
                                :config="endconfig"
                                @dp-change="updateDate($event, 'end')"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ClauseMixin from './ClauseMixin.vue';

    export default {
        name: 'OrderField',
        mixins: [ClauseMixin],
        props: {
            type: {
                type: String,
                default: 'madeOrder',
            }
        },
        data: function() {
            return { 
                tab: ['>', '=='].includes(this.content.clause) ? this.content.clause : '>'
            }
        },
        methods: {
            emitChange: function() {
                let range = this.validateDate();

                if (range.start && range.end) {
                    this.$emit('change', {
                        'id': this.id,
                        'clause': this.tab, 
                        'type': 'madeOrder',
                        'sum': 0,
                        'start': range.start.toISOString(),
                        'end': range.end.toISOString(),
                    });
                }
            },
        }
    }
</script>

